import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import type { CoSupervisorDec } from './types';

type GetCoSupervisorDec = {
  CoSupervisorDec: CoSupervisorDec[];
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useGetCoSupervisorDec = (id: string): GetCoSupervisorDec => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query ($id: ID!) {
        nomination(id: $id) {
          supervisors {
            netId
            email
            confirmedAsCoSupervisor
            department
            coSupervisorDeclarationRemark
          }
        }
      }
    `,
    {
      variables: { id },
      skip: !id,
      fetchPolicy: 'network-only',
    },
  );

  const CoSupervisorDec: CoSupervisorDec[] =
    data?.nomination?.supervisors ?? [];

  return {
    CoSupervisorDec,
    loading,
    error,
    refetch,
  };
};
